import "/src/style.css"
import {getSpellColorCode} from "/src/utilities.js";
import {imageUrls,hidden} from "/src/imgResources.js";
import {enterQuizClickACB} from "../utilities.js"

export function SearchResultView(props){

    return (
    <div>
        <button type="button" className="btn btn-light floating-btn" onClick={enterQuizClickACB}>Start Quiz</button>
        <br/>
        <div class="container-fluid">
            <div class="row">
            {props.searchResults.map(searchResultCB)}
            </div>
            
        </div>
    </div>
    )


    function searchResultCB(result){
        return (
            <div class="col-sm-3">
                <div class="card universal-margin universal-padding">
                {console.log(result)}
                {props.page === 'Houses' ? (
                    <div>
                        <div class="img-card">
                            <img class="card-img-top square-img" src={imageUrls[result.name]} alt={`${result.name} Image`} />
                        </div>
                        <div class="card-body">
                            <h5 class="card-title harry-font">{(result.name)}</h5> 
                            <p class="card-text">Colors: {(result.houseColours)}</p>
                            <p class="card-text">Founder: {(result.founder)}</p>
                        </div>
                    </div>
                ) : props.page === 'Spells' ? (
                    <div>
                        <div class="img-card">
                            {getSpellColorCode(result.light) ? <div class="card-img-top square-img" style={{ height: '40vh', backgroundImage: `radial-gradient(${getSpellColorCode(result.light)}, white, #EFEEED)`, border: `1px solid #EFEEED` }}></div> : 
                            <img class="card-img-top square-img" src={hidden} alt={`${result.name} Image`} onError={hidden}/>
                        }
                            
                        </div>
                        <div class="card-body" style={{height: '26vh'}}>
                            <h4 class="card-title  harry-font">{(result.name)}</h4> 
                            <p class="card-text">Effect: {(result.effect)}</p>
                            <p class="card-text">Type: {(result.type)}</p>
                        </div>
                    </div>
                ) : props.page === 'Elixirs' ? (
                    <div>
                        <div class="img-card" style={{height: '35vh'}}>
                            <img class="card-img-top square-img" src={result.image||hidden} alt={`${result.name} Image`} onError={hidden}/>
                        </div>
                        <div class="card-body" style={{height: '26vh'}}>
                            <h4 class="card-title  text-font">{(result.name)}</h4> 
                            <p class="card-text">Effect: {result.effect  || 'Not Available'}</p>       
                        </div>
                    </div>
                ) : props.page === 'Characters' ? (
                    <div>
                        <div class="img-card">
                            <img class="card-img-top square-img" src={result.image||hidden} alt={`${result.name} Image`} />
                        </div>
                        <div class="card-body">
                            <h4 class="card-title  text-font">{(result.name)}</h4> 
                            <p class="card-text">House: {result.house || 'Not Available'}</p>  
                            <p class="card-text">Patronus: {result.patronus || 'Not Available'}</p>  
                        </div>
                    </div>
                ) : (
                    <img class="card-img-top square-img" src='https://i.pinimg.com/originals/68/8b/d2/688bd2e2fba6756a496640c10465a28e.png' alt="Card image" />
                )}
                
                    <button class="btn" onClick={goToDetailACB}>See Details <span class=" fas fa-info"></span></button>
                    
                </div> 
            </div>
        );

        function goToDetailACB(){
            props.goToDetailHandler(result.id)
            window.location.hash = "/detail"
        }
    }
}